/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { Props, State } from './NavigationView.types.tsx';
import { findViewBy, modifyView } from './updateContainerState.tsx';

export const expandSectionForSelectedView =
	(): Action<State, Props> =>
	async ({ setState, getState }, props) => {
		const { navigationRemote, cloudId, containerId, activeViewId, isActiveContainer } = props;
		if (
			!cloudId ||
			!containerId ||
			!navigationRemote ||
			getState().containers[containerId]?.isLoading ||
			!getState().containers[containerId]?.initialized
		) {
			return;
		}

		if (!isActiveContainer) {
			return;
		}

		const { parent } = findViewBy(
			getState().containers[containerId],
			(innerView) => String(innerView.polarisId) === activeViewId || innerView.id === activeViewId,
		);

		if (parent) {
			setState(
				modifyView(getState(), containerId, (viewToModify) => {
					if (viewToModify.localId === parent.localId) {
						return {
							...viewToModify,
							isExpanded: true,
						};
					}
					return viewToModify;
				}),
			);
		}
	};
